import { Link } from "@tanstack/react-router";
import { categories } from "@/data/products";

interface MobileCategoryBarProps {
  activeCategory?: string;
}

export function MobileCategoryBar({ activeCategory = "all" }: MobileCategoryBarProps) {
  return (
    <div className="md:hidden sticky top-16 z-40 bg-surface-elevated/90 backdrop-blur-xl border-b border-border">
      <div className="flex gap-2 overflow-x-auto px-4 py-3 scrollbar-hide">
        {categories.map((cat) => {
          const isActive = activeCategory === cat.id;
          return (
            <Link
              key={cat.id}
              to="/catalog"
              search={{ category: cat.id }}
              className={`shrink-0 px-4 py-2 min-h-[24px] rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                isActive
                  ? "bg-electric text-electric-foreground shadow-electric"
                  : "bg-card text-muted-foreground hover:bg-accent border border-border"
              }`}
            >
              {cat.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
